import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CandidateModel, IContact} from '../../../core/models';
import {ChatService} from '../../../core/services/chat.service';

export interface IChatRoom {
  createdAt: string;
  message: string;
  users: CandidateModel[];
  sender: CandidateModel;
  read: boolean;
  read_at: string;
}

@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.css']
})
export class ChatBoxComponent implements OnInit {
  @Input() messagesList: IChatRoom[];
  @Input() currentPartner = {} as IContact;
  @Output() goBack = new EventEmitter<boolean>();
  textMessage = '';
  msgOptList = [
    'תודה על פנייתך, אנחנו מתקדמים מול מועמדים אחרים כרגע',
    'ניצור קשר בקרוב'
  ];
  constructor(private chatService: ChatService) { }

  ngOnInit() {
  }

  sendMessage() {
    this.chatService.sendMessage(this.textMessage, this.currentPartner.user._id).subscribe( data => {
      console.log(data);
      if (data.success) {
        this.textMessage = '';
        console.log(data);
        this.messagesList.push(data.data);
      } else {
        alert('התרחשה תקלה בשליחת ההודעה');
      }
    });
  }

  sendTmplMessage(msg) {
    this.textMessage = msg;
    this.sendMessage();
  }

  close() {
    this.goBack.emit(true);
  }
}
